import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ComponentsModule } from 'components/components.module';
import { AdminUserSearchPage } from './admin-user-search';
import { PagesModule } from 'pages/pages.module';

@NgModule({
    declarations: [AdminUserSearchPage],
    imports: [CommonModule, PagesModule, ComponentsModule],
    exports: [AdminUserSearchPage]
})
export class AdminUserSearchPageModule { }
